import React from 'react';
// Import Image component for the logo/profile picture
import { Container, Row, Col, Image } from 'react-bootstrap'; 

const ProfileSection = () => {
  return (
    // Use a light background for the section to make the colored boxes stand out
    <Container className="my-5 py-5 bg-light"> 
       
      <Row className="align-items-stretch">

        {/* Left Side: Large Image */}
        <Col md={6} className="mb-4 mb-md-0">
          <Image 
            // Use the image path for the visual on the left.
            // **ACTION REQUIRED:** Ensure 'profile_main_visual.jpg' is placed 
            // in your 'frontend/public/images/' directory.
            src="/images/Shahadat.jpg" // Using the filename you uploaded
            alt="Textile machinery installation" 
            fluid 
            rounded 
            className="shadow-lg h-100 object-fit-cover" // h-100 to stretch, object-fit-cover to maintain aspect ratio
            style={{ maxHeight: '450px' }} // Set a max height for better control
            
          />
          <p>
            SAHADAT HOSSAIN PRINCE <br />
            Chief Executive Officer (CEO) <br />
            Friends-Tech Corporation
          </p>
        </Col>

        {/* Right Side: Colorful Text Boxes */}
        <Col md={6} className="d-flex mt- flex-column justify-content-between mt-5">
          
          {/* Top Box: Affordable Solutions (Green) */}
          <div className="text-dark p-0 rounded shadow-sm  justify-content-center">
            
            <p>
             Sahadat Hossain Prince is the CEO of Friends-Tech Corporation, leading the company with a strong commitment to innovation, advanced technology, and sustainable growth. With decades of experience in the textile and digital printing industries, he brings deep technical knowledge and strategic leadership to the organization.

            Sahadat began his professional journey at NAF Group, where he gained hands-on expertise in digital printing and embroidery. This technical foundation helped shape his understanding of production processes, customer needs, and evolving market demands. He later expanded his career into sales and marketing, successfully leading initiatives in textile machinery, printing technologies, and industrial solutions.

            A recognized specialist in digital textile printing, textile chemicals, and dyes, Sahadat has played a key role in promoting modern, efficient, and high-quality printing technologies in the industry. His advanced understanding of chemical formulations, color management, and production innovation enables him to deliver reliable and optimized solutions to clients across the textile sector.

            As the CEO of Friends-Tech Corporation, Sahadat integrates his extensive knowledge and leadership skills to ensure the company remains a trusted partner for businesses seeking advanced textile, printing, and engineering solutions. Under his guidance, Friends-Tech continues to expand its footprint as a leader in sustainable, technology-driven industrial development.

            </p>
          </div>     
        </Col>
      </Row>
      <h1 className="text-center mt-5">Our Core Services</h1>
       <Row className="align-items-start m-5 p-3">
                  {/* Left Side: Colorful Boxes */}
                  <Col md={6} className="mb-4 mb-md-0">
                    
                    {/* Box 1: Green with Transparency (80% opacity) */}
                    <div className="text-dark p-2 rounded shadow-sm mb-3"> 
                      <h4>Digital Textile Printing Machines</h4>
                    </div>
                    <div className="text-dark p-2 rounded shadow-sm mb-3"> 
                      <h4>Sublimation Printing </h4>
                    </div>
                    {/* Box 2: Red with Transparency (80% opacity) */}
                  <div className="text-dark p-2 rounded shadow-sm mb-3"> 
                      <h4>Textile pre, post & Finishing Chemicals </h4>
                    </div>
                  </Col>
      
                  {/* Right Side: Colorful Box (Blue/Cyan with Transparency) */}
                  <Col md={6}>
                    {/* Box 3: Cyan/Blue with Transparency (80% opacity) */}
                    
                    {/* Box 1: Green with Transparency (80% opacity) */}
                   <div className="text-dark p-2 rounded shadow-sm mb-3"> 
                      <h4>Textile Accessories & Spare Parts </h4>
                    </div>
                    
                    {/* Box 2: Red with Transparency (80% opacity) */}
                    <div className="text-dark p-2 rounded shadow-sm mb-3"> 
                      <h4>New Textile Technologies & Solutions </h4>
                    </div>
                  </Col>
                </Row>
    </Container>
  );
};

export default ProfileSection;